var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_802_5491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9937 27.375V24.625C22.9937 23.1663 22.4142 21.7674 21.3827 20.7359C20.3513 19.7045 18.9523 19.125 17.4937 19.125C17.4937 19.125 14.1415 19.125 11.9937 19.125C9.84577 19.125 6.49365 19.125 6.49365 19.125C5.03496 19.125 3.63601 19.7045 2.60456 20.7359C1.57311 21.7674 0.993652 23.1663 0.993652 24.625V27.375M17.4937 8.125C17.4937 11.1626 15.0312 13.625 11.9937 13.625C8.95609 13.625 6.49365 11.1626 6.49365 8.125C6.49365 5.08743 8.95609 2.625 11.9937 2.625C15.0312 2.625 17.4937 5.08743 17.4937 8.125Z",
    stroke: "#F5F5F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_802_5491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 28.75,
    fill: "white",
    transform: "translate(-0.00634766 0.625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.59b7d313ae634caf608e4aca194de61a.svg";
export { ForwardRef as ReactComponent };